/**
 * Date / time helpers — pure, no React.
 *
 * The browser `Date` object holds an instant in time; serialization to a
 * string is where wall-clock vs UTC questions show up. These helpers exist
 * so we have ONE place that knows how to produce the various string formats
 * the app needs, and we never accidentally pre-fill an input with UTC.
 */

const pad2 = (n) => String(n).padStart(2, "0");

/**
 * Format a Date in the user's local timezone as `YYYY-MM-DDTHH:MM`, the
 * exact format `<input type="datetime-local">` expects.
 *
 * The standard mistake — `new Date().toISOString().slice(0, 16)` — returns
 * UTC, so a user in US Eastern at 2:00 PM local sees 19:00 (or 18:00 in
 * DST) pre-filled. This helper preserves the local wall clock instead.
 *
 * @param {Date} [d=new Date()]  Reference instant. Defaults to "now".
 * @returns {string}             "2026-02-15T14:30"
 */
export function toLocalDatetimeInputValue(d = new Date()) {
  return (
    `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}` +
    `T${pad2(d.getHours())}:${pad2(d.getMinutes())}`
  );
}

/**
 * Format a Date in the user's local timezone as `YYYY-MM-DD`, the exact
 * format `<input type="date">` expects. Same UTC-pitfall caveat as above.
 *
 * @param {Date} [d=new Date()]
 * @returns {string}             "2026-02-15"
 */
export function toLocalDateInputValue(d = new Date()) {
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}
